import Layout from 'components/layout'
import Link from 'next/link'

declare global {
  interface Window {
    newrelic?: any
  }
}

function ErrorPage({ statusCode }: { statusCode: number }): JSX.Element {
  return (
    <Layout h1SiteName={true}>
      <div className="flex items-center justify-center flex-col py-48">
        <div className="text-gray text-5xl text-center">{{ statusCode }}</div>
        <div className="text-3xl font-bold p-6 text-center">
          Whoops, The page you are looking for is wrong.
        </div>
        <div className="flex items-center justify-center flex-col py-6 desktop:flex-row">
          <Link href="/">
            <div className="flex items-center justify-center flex-none w-80 h-16 m-4 text-black text-xl border border-black">
              Back to Home
            </div>
          </Link>
          <Link href="https://www.novelsnack.com/">
            <div className="flex items-center justify-center flex-none w-80 h-16 m-4 text-white text-xl bg-[#FE6E00]">
              Go to Writer’s Workspace
            </div>
          </Link>
        </div>
      </div>
    </Layout>
  )
}

ErrorPage.getInitialProps = ({ res, err }) => {
  // if (typeof window == 'undefined') {
  //   const newrelic = require('newrelic')
  //   newrelic.noticeError(err)
  // } else {
  //   window.newrelic.noticeError(err)
  // }

  const statusCode = res ? res.statusCode : err ? err.statusCode : 404
  return { statusCode }
}

export default ErrorPage
